import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useSnapshotByEnvironment } from '@/hooks/discovery/snapshot';
import { useEnvironmentScope } from '@/hooks/useEnvironmentScope';
import { ParsedUniqueId } from '@/typings/parseUniqueId';

export const useSnapshot = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;
  const { userId } = useEnvironmentScope();

  const [{ fetching, error, data }] = useSnapshotByEnvironment({
    environmentId: validEnvironmentId,
    uniqueId: uniqueId?.raw ?? '',
    userId,
    pause: uniqueId?.resourceType !== 'snapshot',
  });

  const snapshotQuery = useMemo(() => {
    const definitionEdge = data?.environment.definition?.snapshots.edges?.[0];
    const appliedEdge = data?.environment.applied?.snapshots.edges?.[0];
    return {
      fetching,
      error,
      data: {
        applied: appliedEdge?.node,
        definition: definitionEdge?.node,
        adapterType: data?.environment.adapterType,
      },
    };
  }, [fetching, error, data]);

  return snapshotQuery;
};
